import { useContext } from "react";

import { UserContext } from "@/components/User";

export const useCompanyContext = () => {
  const User = useContext(UserContext);

  if (!User.contextCompany) {
    throw new Error("Company Context can't be used without company (resolved and authenticated session).");
  }

  return User.contextCompany;
};
